/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type { DcaLitigationFileSummaryResponse } from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * SO-32859: feeds the NOVA DCA Management page. processedAt is when the file's rows were processed by this service - no real file-received timestamp exists upstream. filename and processedAt are both absent when no litigation-placement-update file has ever been processed successfully; acceptedCount, rejectedCount and rejectedBreakdown are then all zero/empty rather than an error.
 * @summary Summary of the most recently processed Moriarty litigation-placement-update file.
 */
export const getDcaLitigationFileSummary = (
  options?: SecondParameter<
    typeof backofficeRequest<DcaLitigationFileSummaryResponse>
  >,
) => {
  return backofficeRequest<DcaLitigationFileSummaryResponse>(
    { url: `/api/v1/dca-litigation-file-summary`, method: "GET" },
    options,
  )
}
export type GetDcaLitigationFileSummaryResult = NonNullable<
  Awaited<ReturnType<typeof getDcaLitigationFileSummary>>
>
